import React from 'react';

export function Image({ imagen }) {
    return (
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "center" }}>
            <img src={imagen} />
        </div>
    );
}